import React from 'react';

import { createGlobalStyle, type DefaultTheme, ThemeProvider } from 'styled-components';

import Default from './themes/default';

const defaultTheme: DefaultTheme = Default;

interface Props {
    children: React.ReactNode;
    theme?: DefaultTheme;
}

/**
 * Any sort of css reset should be added here and not scss.
 * There is an issue with useing @import alongside styled-components.
 * See https://styled-components.com/docs/faqs#note-regarding-css-import-and-createglobalstyle
 */
const GlobalStyle = createGlobalStyle`
  body {
   /* Improve text rendering */
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
  }
  svg {
        display: block;
        vertical-align: middle;
        max-width: 100%;
        height: auto;
    }
`;

const StyledThemeProvider = ({ children, theme }: Props) => {
    return (
        <ThemeProvider theme={theme || defaultTheme}>
            <GlobalStyle />
            {children}
        </ThemeProvider>
    );
};

export default StyledThemeProvider;
